import { ApiConnector, setToken } from "common/ApiConnector";
import { useState } from "react";
import { App } from "antd";

const url_endpoint = 'api/v1/instance-text';

export const useIA = (cat_user_id) => {
    const { message } = App.useApp();
    const [text,setText] = useState("");

    const updateToken = async () => {
        await setToken(atob(cat_user_id));
    }

    const fillText = async () => {
        let res = await ApiConnector.get(url_endpoint);
        setText(res.data.text);
    };

    const updateText = async () => {
        let res = await ApiConnector.post(url_endpoint, { text: text });

        if(res.data.success) {
            message.success({
                content: "Texto guardado!"
            });
        } else {
            message.info({
                content: "Error al guardar el texto."
            });
        }
    }

    return {
        updateToken,
        text,
        setText,
        fillText,
        updateText
    };
}

